<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15eGEPS/tc-custom/9781609452360.jpg?1734332474795" alt="This image is the cover for the book Arctic Summer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arctic Summer
      </h1>
      <p class="bookDescription body article font2">
        <b>This “beautifully written and utterly compelling” novel by the acclaimed South African author traces E. M. Forester’s journey of self-discovery (<i>The Times</i>, London).</b><br/>  <br/> The year is 1912, and the SS<i> Birmingham</i> is approaching India. On board is Edward Morgan Forster, a reserved man taunted by writer’s block, attempting to come to terms with his art and his homosexuality. During his travels, the novelist confronts his fraught childhood and falls in unrequited love with his closest friend. He also finds himself surprisingly freed to explore his “minorite” desires as secretary to a most unusual Maharajah.<br/>  <br/> Slowly, the strands of a story begin to gather in Forster’s mind: a sense of impending menace, lust in close confines, under a hot, empty sky. But it will be another twelve years and a second stay in India before the publication of his finest work, <i>A Passage to India</i>.<br/>  <br/> Shifting across the landscapes of India, Egypt, and England, Forster’s life is informed by his relationships—from the Egyptian tram conductor Mohammed el-Adl, to the Greek poet and literary titan C. P. Cavafy. Damon Galgut’s reimagining of Forster’s life is a clear and sympathetic psychological probing of one of Britain’s finest novelists.<br/>  <br/><b>“Galgut inhabits [Forster] with such sympathetic completeness, and in prose of such modest excellence that he starts to breathe on the page.” —<i>Financial Times</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Damon Galgut
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fec9e08